// extracted by mini-css-extract-plugin
export default {"cardHeader":"ImageCardHeader_cardHeader__mYhYW"};